import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Row, Col, Spin, Icon } from 'antd';
import {
  fetchEmailTemplate,
  fetchEmailMetaData
} from '../actions/sessionActions';
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const columns = [
  {
    title: 'Description',
    width: 35
  },
  {
    title: 'Notification Event',
    width: 20
  },
  {
    title: 'File Upload',
    key: 'file_upload',
    width: 25
  },
  {
    title: 'Created At',
    width: 20
  }
];

export class EmailTemplate extends Component {
  constructor() {
    super();
    this.state = { enterpriseId: undefined, enterprise: null };
  }

  componentDidMount() {
    this.props.fetchEmailMetaData().then(res => {
      if (res.meta.status === 200) {
        this.props.fetchEmailTemplate();
      }
    });
  }

  mapEventName(id) {
    if (id) {
      const { notification } = this.props.emailTemplate;
      const filtered = notification.list.filter(
        item => item.notification_event_id === id
      );
      return filtered.length > 0 && filtered[0].notification_event_name;
    }
  }

  render() {
    const { emailTemplate } = this.props;
    return (
      <div>
        <Row>
          <Col span={24} className="margin-bottom-10">
            {emailTemplate.isFetching ? (
              <Spin indicator={antIcon} />
            ) : (
              <Fragment>
                {emailTemplate.list.length <= 0 ? (
                  <div>&nbsp; No Data</div>
                ) : (
                  <Fragment>
                    <table className={`ant-table ant-table-small width-100pt`}>
                      <thead className="ant-table-thead">
                        <tr>
                          {columns.map((item, i) => (
                            <th
                              className="padding-8"
                              key={i}
                              width={`${item.width}%`}
                            >
                              {item.title}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="ant-table-tbody">
                        {emailTemplate.list.map((item, i) => (
                          <tr key={i}>
                            <td className="padding-8">{item.name}</td>
                            <td className="padding-8">
                              {this.mapEventName(item.notification_event_id)}
                            </td>
                            <td className="padding-8">
                              <a
                                href={`https://pyck-res-bucket.s3.amazonaws.com/${item.file_upload}`}
                              >
                                {item.file_upload}
                              </a>
                            </td>
                            <td className="padding-8">{item.created_at}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Fragment>
                )}
              </Fragment>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

EmailTemplate.propTypes = {
  emailTemplate: PropTypes.object,
  match: PropTypes.object,
  fetchEmailTemplate: PropTypes.func,
  fetchEmailMetaData: PropTypes.func
};

EmailTemplate.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  emailTemplate: state.session.emailTemplate
});

const mapDispatchToProps = dispatch => ({
  fetchEmailTemplate: () => dispatch(fetchEmailTemplate()),
  fetchEmailMetaData: () => dispatch(fetchEmailMetaData())
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EmailTemplate)
);
